<template>

  <div class="columns is-centered is-vcentered">

    <div class="column is-three-fifths-desktop is-four-fifths-tablet">

      <div class="card" style="padding: 30px 30px; margin-top: 35px;" :style="{opacity: (submitInProgress ? 0.3 : 1)}">
        <div class="card-content">

          <b-field label="Matches" style="text-align: left;">
            <b-select v-model="matchSelector" placeholder="Select..." expanded required>
              <option value="basic">Schedule time for unplayed matches</option>
              <option value="all">Schedule time for all matches</option>
            </b-select>
          </b-field>


          <b-field label="Match interval (minutes)" style="text-align: left;">
            <b-select v-model="matchIntervalMinutes" placeholder="Select..." expanded required>
              <option :value="(val*5)" v-for="val in 6">{{val*5}}</option>
            </b-select>
          </b-field>


          <b-field label="Match break (minutes)" style="text-align: left;">
            <b-select v-model="matchBreaksMinutes" placeholder="Select..." expanded required>
              <option :value="(val*5)" v-for="val in 12">{{val*5}}</option>
            </b-select>
          </b-field>


          <b-field label="Tournament date" style="text-align: left; margin-top: 40px;">
            <b-datepicker v-model="startTime" placeholder="Click to select..." icon="calendar-check" icon-pack="fas"
                          required :date-formatter="dateFormatter">
            </b-datepicker>
          </b-field>

          <b-field label="Start time" style="text-align: left;">
            <b-timepicker v-model="timeOfDay" placeholder="Click to select..." icon="clock" icon-pack="fas" required :hour-format="'24'">
            </b-timepicker>
          </b-field>


          <h3 style="font-weight: 600; font-size: 1rem; text-align: left; margin-top: 35px;">Match order</h3>
          <b-taglist>
            <b-tag type="is-info" v-for="(event, index) in eventOrder" v-if="tournament">
              <b-icon pack="fas" icon="arrow-left" size="is-small" @click.native="moveEventOrder(index, -1)" style="cursor: pointer;" /> &nbsp;
              {{ event.name }}
              &nbsp; <b-icon pack="fas" icon="arrow-right" size="is-small" @click.native="moveEventOrder(index, 1)" style="cursor: pointer;" />

            </b-tag>
          </b-taglist>

        <p v-if="failedSubmit" style="margin-top: 27px; text-align: left; color: red;">Please make sure you complete all fields.</p>
        <p v-if="matchBreaksMinutes && matchIntervalMinutes && matchIntervalMinutes >= matchBreaksMinutes" style="margin-top: 27px; text-align: left; color: red;"><strong style="color: red;">WARNING: Players will have no breaks between matches.</strong><br />To fix this issue, increase "Match break" above.</p>

        <div style="text-align: right;">
          <button class="button is-primary" style="margin-top: 25px; margin-bottom: -10px;" @click="triggerSubmit">Generate</button>
        </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from '../request';
import TournamentDataMixin from '../mixins/TournamentDataMixin.js';

export default {
  mixins: [ TournamentDataMixin ],

  data: function() {
    return {
      startTime: null,
      timeOfDay: null,
      matchSelector: 'all',

      matchBreaksMinutes: null,
      matchIntervalMinutes: null,

      eventOrder: [],

      submitInProgress: false,
      failedSubmit: false
    }
  },

  watch: {
    tournament: {
      immediate: true,

      handler() {
        if (this.tournament) {
          this.matchIntervalMinutes = this.tournament.matchIntervalMinutes;
          this.matchBreaksMinutes = this.tournament.matchIntervalMinutes;

          this.startTime = new Date(this.tournament.startTimeReal);
          this.timeOfDay = new Date('2018-12-31 10:00');


          this.eventOrder = this.tournament.events.slice();
        }
      }
    },
  },

  methods: {
    dateFormatter: function(date) {
      return date.toJSON().slice(0,10);
    },

    moveEventOrder(index, diff) {
      if (index+diff >= 0 && index+diff < this.eventOrder.length) {
        let temp = this.eventOrder[index];
        this.eventOrder[index] = this.eventOrder[index+diff];
        this.eventOrder[index+diff] = temp;

        this.$forceUpdate();
      }
    },

    triggerSubmit: function() {

      if (this.submitInProgress) {
        return /* don't do multiple requests */;
      }

      let vm = this;
      vm.submitInProgress = true;
      vm.failedSubmit = false;

      let tournamentId = this.$route.params.id;

      axios.post('/api/tournament/' + tournamentId + '/schedule', {

        startTime: this.startTime,
        timeOfDay: this.timeOfDay,

        matchSelector: this.matchSelector,

        matchBreaksMinutes: this.matchBreaksMinutes,
        matchIntervalMinutes: this.matchIntervalMinutes,

        eventOrder: this.eventOrder.map(e => e.id),
        id: this.tournament.id
      })
        .then(function(response){
          vm.submitInProgress = false;
          vm.failedSubmit = false;

          vm.$store.dispatch('tournamentEventsChanged', { tournamentId: tournamentId, events: response.data, suggestedPage: '/tournaments/' + tournamentId + '/matches' });
        })
        .catch(function(){
          vm.submitInProgress = false;
          vm.failedSubmit = true;
        });

    }
  },

  name: 'tournament-scheduler'
}
</script>



<style scoped>

</style>